// A WP project should always have a custom.js
// menu-header
window.onload = () => {


};